import popsss from 'lib/popsss';

import { ACTION_TYPES } from '../constants';

// ========================
// For server interactions:
// ========================

export function loadFaqsStart() {
  return {
    type: ACTION_TYPES.LOAD_FAQS_START,
  };
}

export function loadFaqsSuccessful(faqsData) {
  return {
    type: ACTION_TYPES.LOAD_FAQS_SUCCESSFUL,
    faqsData,
  };
}

export function loadFaqsFailed(error) {
  return {
    type: ACTION_TYPES.LOAD_FAQS_FAILED,
    error,
  };
}

// Added action to load permissions into store.

export function loadEditPerm(editPerm) {
  return {
    type: ACTION_TYPES.LOAD_EDIT_PERM,
    editPerm,
  };
}

export function loadEditGlobalPerm(editGlobalPerm) {
  return {
    type: ACTION_TYPES.LOAD_EDIT_GLOBAL_PERM,
    editGlobalPerm,
  };
}

// ====================================
// For user inetractions on FAQS level:
// ====================================
export function loadFaqs() {
  return (dispatch) => {
    dispatch(loadFaqsStart());
    return popsss
      .getJSON('/faq/index')
      .done((result) => {
        dispatch(loadFaqsSuccessful(result.gs));
      })
      .fail((error) => {
        dispatch(loadFaqsFailed(error));
      });
  };
}
